import propTypes from 'prop-types';
import * as S from './styles';

const Button = ({ variant = 'default', children, ...props }) => {
  return (
    <S.Button $variant={variant} {...props}>
      {children}
    </S.Button>
  );
};

Button.propTypes = {
  variant: propTypes.oneOf(['default', 'primary', 'outlined']),
  color: propTypes.string,
  children: propTypes.node.isRequired,
  onClick: propTypes.func,
  disabled: propTypes.bool,
  type: propTypes.oneOf(['button', 'submit', 'reset']),
};

Button.defaultProps = {
  variant: 'default',
  color: null,
  onClick: null,
  disabled: false,
  type: 'button',
};

export default Button;
